import xContestServices from 'src/services/xcontest'
import { XContestTypes } from 'src/redux/types/xContest'
import { action } from 'typesafe-actions'
import { getErrorHelper } from 'src/utils/response-helpers'

export const getAllContestAction = () => {
  return async (dispatch: any) => {
    try {
      const response: any = await xContestServices.getAllContests()

      const payload = response.data.data.contest
      console.log(payload, 'I am here')

      dispatch(action(XContestTypes.GET_ALL_XCONTESTS_SUCCESS, payload))
    } catch (error) {
      getErrorHelper(error)
    }
  }
}

export const getUserContestAction = () => {
  return async (dispatch: any) => {
    try {
      const response: any = await xContestServices.getUserContests()
      const payload = response.data.data.contestPlans

      dispatch(action(XContestTypes.GET_USER_XCONTESTS_SUCCESS, payload))
    } catch (error) {
      getErrorHelper(error)
    }
  }
}

export const joinContestAction = ({ joinForm, onSuccess, onError }: any) => {
  return async (dispatch: any) => {
    try {
      const response: any = await xContestServices.joinXcontest(joinForm)

      if (!response.data.data.successful) {
        onError?.(response.data.data.server_response)
      } else {
        onSuccess?.(response.data.data.server_response)
        dispatch(action(XContestTypes.JOIN_XCONTEST_SUCCESS))
        dispatch(action(XContestTypes.GET_USER_XCONTESTS_CALL))
      }
    } catch (error) {
      onError?.(error)
      console.log(error)
    }
  }
}

export const getUserActivitiesAction = ({ id }: any) => {
  return async (dispatch: any) => {
    try {
      const response: any = await xContestServices.getUserContestsActivities(id)

      const payload = response.data.data.activities
      console.log(payload, 'i am activities')
      dispatch(
        action(XContestTypes.GET_USER_XCONTEST_ACTIVITIES_SUCCESS, payload)
      )
    } catch (error) {
      getErrorHelper(error)
    }
  }
}

export const getLeaderBoardAction = ({ id }: any) => {
  return async (dispatch: any) => {
    try {
      const response: any = await xContestServices.getUserContestLeaderboard(id)

      const payload = response.data.data.leaderboard
      console.log(payload, 'i am leaderboard')

      dispatch(
        action(XContestTypes.GET_USER_XCONTEST_LEADERBOARD_SUCCESS, payload)
      )
    } catch (error) {
      getErrorHelper(error)
    }
  }
}
